import HomePage from "pages/HomePage/HomePage";
import RegisterPage from "pages/AuthPage/RegisterPage/RegisterPage";
import LoginPage from "pages/AuthPage/LoginPage";
import ForgotPasswordPage from "pages/AuthPage/ForgotPasswordPage";
import ProfilePage from "pages/ProfilePage/ProfilePage";
import ErrorPage from "pages/ErrorPage/ErrorPage";
import { AUTH_STATE_ENUM } from "constant/auth";
import ProfileEditPage from "pages/ProfilePage/ProfileEditPage";
import ResetPasswordPage from "pages/AuthPage/ResetPasswordPage";
import AboutUsPage from "pages/AboutUsPage/AboutUsPage";
import MCCPage from "pages/EventPage/MCCPage/MCCPage";
import CompanyVisitPage from "pages/EventPage/CompanyVisitPage/CompanyVisitPage";
import MCCRegistrationPage from "pages/EventPage/MCCPage/MCCRegistrationPage";
import CompanyVisitRegistrationPage from "pages/EventPage/CompanyVisitPage/CompanyVisitRegistrationPage";
import SeminarPage from "pages/EventPage/SeminarPage/SeminarPage";
import SeminarRegistrationPage from "pages/EventPage/SeminarPage/SeminarRegistrationPage";
import JobExpoPage from "pages/JobExpoPage/JobExpoPage";
import JobExpoDetailPage from "pages/JobExpoPage/JobExpoDetailPage";

const basicRoutes = [
  {
    path: "/",
    element: <HomePage />,
    title: "",
  },
  {
    path: "/about-us",
    element: <AboutUsPage />,
    title: "About Us",
  },
  {
    path: "*",
    element: <ErrorPage />,
    title: "Error",
  },
];
const authRoutes = [
  {
    path: "/login",
    element: <LoginPage />,
    authState: AUTH_STATE_ENUM.NON_LOGIN,
    title: "Login",
  },
  {
    path: "/register",
    element: <RegisterPage />,
    authState: AUTH_STATE_ENUM.NON_LOGIN,
    title: "Register",
  },
  {
    path: "/forgot-password",
    element: <ForgotPasswordPage />,
    authState: AUTH_STATE_ENUM.NON_LOGIN,
    title: "Forgot Password",
  },
  {
    path: "/reset-password",
    element: <ResetPasswordPage />,
    authState: AUTH_STATE_ENUM.NON_LOGIN,
    title: "Reset Password",
  },
];

const profileRoutes = [
  {
    path: "/profile",
    element: <ProfilePage />,
    authState: AUTH_STATE_ENUM.LOGIN,
    title: "Profile",
  },
  {
    path: "/profile/edit",
    element: <ProfileEditPage />,
    authState: AUTH_STATE_ENUM.LOGIN,
    title: "Edit Profile",
  },
];

const eventRoutes = [
  {
    path: "/mini-case-competition",
    element: <MCCPage />,
    title: "Mini Case Competition",
  },
  // {
  //   path: "/mini-case-competition/registration",
  //   element: <MCCRegistrationPage />,
  //   title: "Mini Case Competition Registration",
  //   authState: AUTH_STATE_ENUM.LOGIN,
  // },
  {
    path: "/company-visit",
    element: <CompanyVisitPage />,
    title: "Company Visit",
  },
  // {
  //   path: "/company-visit/registration",
  //   element: <CompanyVisitRegistrationPage />,
  //   title: "Company Visit Registration",
  //   authState: AUTH_STATE_ENUM.LOGIN,
  // },
  {
    path: "/seminar",
    element: <SeminarPage />,
    title: "Seminar",
  },
  // {
  //   path: "/seminar/registration",
  //   element: <SeminarRegistrationPage />,
  //   title: "Seminar Registration",
  //   authState: AUTH_STATE_ENUM.LOGIN,
  // },
  {
    path: "/job-expo",
    element: <JobExpoPage />,
    title: "Job Expo",
  },
  {
    path: "/job-expo/:id",
    element: <JobExpoDetailPage />,
    title: "Job Expo Detail",
  },
];

const routes = [
  ...basicRoutes,
  ...authRoutes,
  ...profileRoutes,
  ...eventRoutes,
];

export default routes;
